import React from 'react'
import { Tooltip } from './tooltip'

/**
 * A simple progress bar component that displays a horizontal bar indicating progress.
 * It can be used to show the progress of a task or operation.
 * @param percentage - The progress value (0-100) to display on the bar. Can also be a string with a percentage (e.g., '50%').
 * @param color - The color of the progress bar.
 * @param tooltip - Optional tooltip text to display when hovering over the progress bar.
 * @param className - Additional classes for styling the progress bar.
 */
export const ProgressBar: React.FC<{
  percentage?: number | string
  color?: string
  tooltip?: string
  className?: string
}> = ({ percentage, color, tooltip, className }) => {
  const value = typeof percentage === 'number' ? percentage : parseFloat((percentage || '0').replace('%', ''))
  const bar = (
    <div className={`relative h-[4px] w-full rounded-full bg-gray-200 ${className}`}>
      <div className={`absolute left-0 top-0 h-full ${color} rounded-full`} style={{ width: `${value}%` }} />
    </div>
  )

  return tooltip ? <Tooltip text={tooltip}>{bar}</Tooltip> : bar
}
